import { render, staticRenderFns } from "./Financije.vue?vue&type=template&id=fba20d64&"
import script from "./Financije.vue?vue&type=script&lang=js&"
export * from "./Financije.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports